import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-popover-secondary',
  templateUrl: './popover-secondary.component.html',
  styleUrls: ['./popover-secondary.component.scss']
})
export class PopoverSecondaryComponent implements OnInit {

  @Output() closeCallback = new EventEmitter();

  isFull = false;
  @Input() customStyle: string;

  ngOnInit() {
    document.getElementsByTagName('html')[0].style.overflow = 'hidden';
  }

  onCloseClick = (): void  => {
    document.getElementsByTagName('html')[0].style.overflow = 'auto';
    this.closeCallback.emit();
  }



}
